export default __webpack_public_path__ + "static/media/disNoneAtt.0bd15d64.svg";